import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header";

const getExpenseDetails = (id) => {
  return axios.get(API + "expenses/" + id + "/", {
    headers: authHeader(),
  });
};

const finalizeExpense = (id) => {
  return axios.post(
    API + "expenses/" + id + "/finalize/",
    {},
    { headers: authHeader() }
  );
};

const ViewExpenseService = {
  getExpenseDetails,
  finalizeExpense,
};

export default ViewExpenseService;
